import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

export default function CancelPendingRequestDialog({ open, request, cancelling = false, error, onClose, onConfirm }) {
  const person = [request?.usuarioNombre, request?.usuarioApellido].filter(Boolean).join(' ');
  return (
    <Dialog open={open} onClose={cancelling ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cancelar cambios</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1} sx={{ overflowWrap: 'anywhere' }}>
          <Typography>Se quitará esta solicitud pendiente. Los datos actuales se mantienen.</Typography>
          <Typography variant="body2"><strong>Tipo:</strong> {request?.type || 'Solicitud pendiente'}</Typography>
          <Typography variant="body2"><strong>Usuario:</strong> {[person, request?.usuarioEmail].filter(Boolean).join(' · ') || 'No registrado'}</Typography>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', gap: 1 }}>
        <Button type="button" onClick={onClose} disabled={cancelling}>Volver</Button>
        <Button type="button" color="error" variant="contained" onClick={onConfirm} disabled={cancelling}>
          {cancelling ? 'Cancelando...' : 'Sí, cancelar cambios'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
